<template>
  <svg><use :xlink:href="`${publicPath}icons/` + weight + '.svg#' + name"></use></svg>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    weight: {
      default: 'light',
    },
  },
  computed: {
    publicPath() {
      return process.env.BASE_URL || '/'
    },
  },
}
</script>

<style></style>
